import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, onUnmounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router"
import { Toast } from "vant"
import { cheackQuery, pickQueryParam, nativeToLogin, ToBack } from "@/uitls/native";
import { useI18n } from "vue-i18n";
import { userLookOrSend } from "@/api/php/player";
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import { addQueryParams, formatDate } from "@/uitls/uitls";
import EventBus from "@/uitls/EventBus";
import { Storage } from "@/uitls/Storage";
import Platform from "@/config/platform";
import SpinPointerComponent from "@/views/me/SpinPointerComponent.vue"
import PrizeResultModal from "@/views/me/PrizeResultModal.vue"
import {
    encryptionGetPrizeInfo,
    encryptionGetEverydayReward,
    evcryptionSpinPulseGo,
    evcryptionExchangePrize
} from "@/api/php/me";
import { load } from "protobufjs";


export default /*#__PURE__*/_defineComponent({
  name: 'LotteryEvent',
  setup(__props, { expose }) {
  expose();

const piniaStore = usePiniaState();
const { user, isYk } = storeToRefs(piniaStore);
const { toLogin } = piniaStore;
const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const showTopBar = ref(true);
const lottery_bg_icon = require("@/assets/images/lottery_bg_icon.png");

const suipian_top = require("@/assets/images/suipian_top.png");
const suipian_bottom = require("@/assets/images/suipian_bottom.png");
const zhuanpan_top = require("@/assets/images/zhuanpan_top.png");
const zhuanpan_bottom = require("@/assets/images/zhuanpan_bottom.png");

const click_bg = require("@/assets/images/lunpan_start.png");
const click_text = require("@/assets/images/click.png")
const notice_bg_icon = require("@/assets/images/notice_bg.png");
const everyday_bg_icon = require("@/assets/images/everyday_bg.png");
const everyday_icon = require("@/assets/images/everyday_icon.png");
const exchangeGoods = require("@/assets/images/exchangeGoods.png");
const exchange_bg_icon = require("@/assets/images/exchange_bg.png");
const goods1_bg = require("@/assets/images/goods1_bg.png");
const goods2_bg = require("@/assets/images/goods2_bg.png");
const goods3_bg = require("@/assets/images/goods3_bg.png");
const suipian = require("@/assets/images/suipian_icon.png");
const activeRulebg = require("@/assets/images/activeRule_bg.png");
const pointerImg = require('@/assets/images/pointer.png');
const highlightSectorImg = require("@/assets/images/shanxin.png");
const lunpan0 = require("@/assets/images/p0.png");
const xxhgIcon = require("@/assets/images/xxhg.png");

const rule_html = ref("");
const spinRef = ref(null); // 获取子组件实例
const prizeIndex = ref(); // 抽奖结果索引
const showResult = ref(false);
const resultIcon = require('@/assets/images/p1.png');
const zooming = ref(false);
let my_fid = ref('');

const prizeList = ref([]);
// 前 2 项
const prizeList0 = computed(() => prizeList.value.slice(0, 2))
// 第 3 项 到 倒数第 2 项
const prizeList1 = computed(() => prizeList.value.slice(2, -1))

const prizeLunboList = ref([]);

const notice = ref('');
const suipianCount = ref(0);
const spinCount = ref(0);
//0=未完成每日任务，1=可领取， 2=已领取
const spinAvail = ref();
const spinAvailText = ref();
const XXHG = "XXHG";
const prizeResult = ref({});
const showComfirmAlert = ref(false);
let selectExchangeIndex = -1;
let prizeLoading = false;
const ruleSection = ref(null);
const exchangeRef = ref(null);
// 固定的“谢谢参与”奖项
const thankObj = {
  sku: XXHG,
  cover: xxhgIcon,
  main_img: lunpan0
}

onMounted(async () => {

    // let { os, fid, token, uid, fastkey, channel, customerId } = route.query;
    let os = pickQueryParam(route, 'os');
    const token = pickQueryParam(route, 'token');
    if (os && os != "h5") {
        if (token == undefined || token == "" || token == "0") {
            await router.replace({
                path: route.path,
                query: {}           // 空对象 → URL 里不再有 ? 后面任何参数
            });
            os = 'h5';
            Storage.clear();
        }
    }
    cheackQuery(route);

    const fid = pickQueryParam(route, 'fid');
    const uid = pickQueryParam(route, 'uid');
    const fastkey = pickQueryParam(route, 'fastkey');
    const channel = pickQueryParam(route, 'channel');
    const customerId = pickQueryParam(route, 'customerId');


    const loading = Toast.loading({
        message: "loading...",
        forbidClick: false,
        loadingType: 'spinner',
        duration: 0
    });
    if (os && os != "h5") {
        //app端跳入
        if (token == undefined || token == "" || token == "0") {
            //弹窗登录
            EventBus.emit('showLogin', { refresh: true });

        } else {
            my_fid.value = fid + '';
            isYk.value = false;
            Storage.set('fid', fid);
            Storage.set('token', token);
            user.value.token = token;
            Storage.set('uid', uid);
            Storage.set('fastkey', fastkey);
            Storage.set('customerId', customerId);
            Platform.channel = Number(channel);
            console.log('channel', channel);
        }
    } else {

        showTopBar.value = true;
        console.log(user.value.token);
        await toLogin();
        my_fid.value = user.value.fid + '';
        if (isYk.value) {
            EventBus.emit('showLogin', { refresh: true });
        }
    }

    await getPrizeInfo();
    loading.clear();
});

EventBus.on("phpLoginSuccessNotification", () => {

    getPrizeInfo();
});

onUnmounted(() => {
    Toast.clear();
});

watch(spinAvail, (newVal, oldVal) => {
    if (newVal == 0) {
        spinAvailText.value = t("未达成");
    } else if (newVal == 1) {
        spinAvailText.value = t("领取");
    } else if (newVal == 2) {
        spinAvailText.value = t("已领取");
    }
});

const getPrizeStatusText = (prize) => {

    if (prize.own > 0) {
        return t("已领取");
    } else {
        if (suipianCount.value >= prize.price) {
            return t("领取");
        } else {
            return t("未达成");
        }

    }
};
// 获取奖品信息
const getPrizeInfo = async () => {
    let customerId = Storage.get("customerId");
    let token = Storage.get("token");
    const res: any = await encryptionGetPrizeInfo();
    if (res.code == 200 && res.data) {
        
        prizeList.value = res.data.prize;
        notice.value = res.data.notice;
        rule_html.value = res.data.html_rule;
        suipianCount.value = res.data.pecahani;
        spinCount.value = res.data.spin;
        spinAvail.value = res.data.spin_avail;

        prizeLunboList.value = generateSlots(prizeList.value);
        
        // const SLOTS = 8;
        // if (prizeList.value.length > 4) {
        //     let suipianObj = prizeList.value[prizeList.value.length - 1];
        //     let thankObj = {
        //         "sku": XXHG,
        //         "cover": xxhgIcon,
        //         "main_img": lunpan0
        //     }
        //     let jifenObj = thankObj;
        //     if (prizeList.value.length > 5) {
        //         jifenObj = prizeList.value[2];
        //     }
        //     prizeLunboList.value = [
        //         thankObj,
        //         prizeList.value[0],
        //         suipianObj,
        //         jifenObj,
        //         prizeList.value[4],
        //         prizeList.value[3],
        //         prizeList.value[1],
        //         suipianObj
        //     ];
        // }
    }
};

// 生成 8 格 Slot 的函数
function generateSlots(list) {
  const SLOTS = 8
  if (!list.length) return []

  // 最后一个条目当“碎片”
  const suipianObj = list[list.length - 1]

  // 计算需要补多少个碎片
  const coreCount = 1 + list.length     // thankObj + 真实奖品数
  const fillerCount = Math.max(0, SLOTS - coreCount)

  // 按均匀间隔算出 filler 要放到哪些下标
  const interval = SLOTS / (fillerCount + 1)
  const fillerIndices = Array.from({ length: fillerCount }, (_, i) =>
    Math.floor((i + 1) * interval)
  )

  // 准备空数组
  const slots = Array(SLOTS).fill(null)

  // 1) 第 0 格放 thankObj
  slots[0] = thankObj

  // 2) 在计算好的位置放碎片
  fillerIndices.forEach(idx => {
    // 确保不覆盖第 0 格
    if (idx > 0 && idx < SLOTS) {
      slots[idx] = suipianObj
    }
  })

  // 3) 剩下的空格，依次放真实奖品（超过就截断）
  let pi = 0
  for (let i = 0; i < SLOTS; i++) {
    if (slots[i] === null && pi < list.length) {
      slots[i] = list[pi++]
    }
  }

  return slots
}

const checkShowLogin = () => {
    if (user.value.token && user.value.token.length > 0) {
        return true;
    } else {
        EventBus.emit('showLogin', { refresh: true });
        return false;
    }
}

const startSpin = async () => {

    if (!checkShowLogin()) {
        return;
    }
    if (spinCount.value == 0) {
        return;
    }
    if (prizeLoading) {
        return;
    }
    prizeLoading = true;
    // 先进场缩放
    zooming.value = true;
    // 0.2s 后还原
    setTimeout(() => (zooming.value = false), 200);

    // 记录动画开始时间
    const t0 = performance.now();
    if (spinRef.value) {
        spinRef.value.startRotate();
    }

    //调用抽奖接口
    try {

        const res: any = await evcryptionSpinPulseGo();

        if (res.code == 200 && res.data) {
            const sku = res.data.sku.length > 0 ? res.data.sku : XXHG;
            const candidateIndices = prizeLunboList.value.reduce((arr, item, idx) => {
                if (item.sku == sku) {
                    arr.push(idx);
                }
                return arr;
            }, []);
            // 如果有匹配项，就随机取一个下标
            if (candidateIndices.length > 0) {
                const randomIdx = candidateIndices[
                    Math.floor(Math.random() * candidateIndices.length)
                ];
                prizeIndex.value = randomIdx;

            } else {
                prizeIndex.value = 0;
            }
            // 4️⃣ 保证“慢→快→匀速”阶段至少跑 1500ms
            const elapsed = performance.now() - t0;
            const minPhase = 2000;   // 需要跑完的最小时长
            const waitTime = Math.max(0, minPhase - elapsed);
            setTimeout(() => {
                // 3. 缓动停到目标格子
                spinRef.value.stopRotate(prizeIndex.value, { laps: 5, duration: 3000 });
            }, waitTime);

            if (spinCount.value > 0) {
                spinCount.value -= 1;
            }
        } else {
            Toast({ message: res.msg, type: 'fail' });
            spinRef.value.resetRotate();
            prizeLoading = false;
        }
    } catch (error) {
        Toast({ message: t("数据异常或网络异常"), type: 'fail' });
        spinRef.value.resetRotate();
        prizeLoading = false;
    }

};

//抽奖中的回调
const handlePrize = (index) => {
    console.log('🎉 抽中 index：', index);
    if (prizeLunboList.value.length > index) {
        prizeResult.value = prizeLunboList.value[index];
        if (prizeResult.value.sku == "spin_pecahani") {
            suipianCount.value += 1;
        }
        setTimeout(() => {
            showResult.value = true;
            prizeLoading = false;
        }, 500);
    }
};

//前往积分商城
const getEverydayReward = async () => {
    if (!checkShowLogin()) {
        return;
    }

    // 前往积分商城
    const time = new Date().getTime();
      //今天的日期
    const day = formatDate(time);
    Storage.set("jfStoreDay", day);
    router.push(`/integralwallet`);

    // const res: any = await encryptionGetEverydayReward();

    // if (res.code == 200 && res.data) {

    //     const count = res.data.spin_avail;
    //     spinCount.value += count;
    //     spinAvail.value = 2;
    // } else {
    //     Toast({ message: res.msg, type: 'fail' });
    // }
};

//兑换奖品的点击 index为0=1等奖，
const claimPrizeWithIndex = (index) => {
    if (prizeList.value.length > index) {
        selectExchangeIndex = index;
        showComfirmAlert.value = true;
    }
}

const beforeSubmitClose1 = async (action) => {
    if (action === 'confirm') {
        if (selectExchangeIndex == -1) {
            return true;
        }
        if (prizeList.value.length <= selectExchangeIndex) {
            return true;
        }
        let obj = prizeList.value[selectExchangeIndex];
        prizeResult.value = obj;
        let ret: any = await evcryptionExchangePrize({
            sku: obj.sku
        });
        if (ret.code == 200) {
            Toast({ message: t('兑换成功'), type: 'success' });
            getPrizeInfo();
            showResult.value = true;
            return true;
        } else {
            // console.log(ret);
            const msg = ret.msg || t('兑换失败');
            Toast({ message: msg, type: 'fail' });
            return true;
        }
    } else {
        return true;
    }
};

const duihuanButtonStatus = (prize) => {
    if (prize.own > 0) {
        return true;
    } else {
        if (suipianCount.value >= prize.price) {
            return false;
        }
        return true;
    }
};

const ruleClick = () => {
    if (ruleSection.value) {
        ruleSection.value.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
};

const moveToExchangeArea = () => {
    if (exchangeRef.value) {
        exchangeRef.value.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}


const __returned__ = { piniaStore, user, isYk, toLogin, t, router, route, showTopBar, lottery_bg_icon, suipian_top, suipian_bottom, zhuanpan_top, zhuanpan_bottom, click_bg, click_text, notice_bg_icon, everyday_bg_icon, everyday_icon, exchangeGoods, exchange_bg_icon, goods1_bg, goods2_bg, goods3_bg, suipian, activeRulebg, pointerImg, highlightSectorImg, lunpan0, xxhgIcon, rule_html, spinRef, prizeIndex, showResult, resultIcon, zooming, my_fid, prizeList, prizeList0, prizeList1, prizeLunboList, notice, suipianCount, spinCount, spinAvail, spinAvailText, XXHG, prizeResult, showComfirmAlert, selectExchangeIndex, prizeLoading, ruleSection, exchangeRef, thankObj, getPrizeStatusText, getPrizeInfo, generateSlots, checkShowLogin, startSpin, handlePrize, getEverydayReward, claimPrizeWithIndex, beforeSubmitClose1, duihuanButtonStatus, ruleClick, moveToExchangeArea, ToBack, SpinPointerComponent, PrizeResultModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})